<template>
  <div class="animated fadeIn mt-3" id="report">
    <h1 class="text-uppercase font-weight-bold">Estadísticas Stock Fruta</h1>
    <b-card id="element-to-hide" data-html2canvas-ignore="true">
      <b-row>
        <b-col sm="12" md="4" lg="4">
          <b-form-group label="Exportadora">
            <b-form-select
              size="sm"
              id="client_customer"
              v-model="client_customer"
              :options="client_customer_options"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col sm="12" md="4" lg="4">
          <b-form-group label="Especie">
            <b-form-select size="sm" id="product" v-model="product" :options="product_options"></b-form-select>
          </b-form-group>
        </b-col>
        <b-col sm="12" md="4" lg="4">
          <b-form-group label="Tipo producto">
            <b-form-select
              size="sm"
              id="product_type"
              v-model="product_type"
              :options="product_type_options"
            ></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>
    <div>
      <kpis
        :client_customer="client_customer"
        :product="product"
        :product_type="product_type"
        v-if="ready"
        @chart-ready="beginChartMount($event)"
      />
      <b-row>
        <b-col :lg="4" :md="4" :sm="12">
          <b-card v-if="beginMount[0]" class="chart">
            <h4>Antiguedad de PT</h4>
            <stays
              chartId="stays"
              :client_customer="client_customer"
              :product="product"
              :product_type="product_type"
              v-if="ready"
              @chart-ready="beginChartMount($event)"
            />
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card> </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import Kpis from "./Kpis.vue";
import Stays from "./Stays.vue";

export default {
  name: "charts",
  components: {
    Kpis,
    Stays
  },
  data() {
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    // 15th two months prior
    const minDate = new Date(today);
    minDate.setMonth(minDate.getMonth() - 1);
    // 15th in two months
    const maxDate = new Date(today);

    return {
      ready: false,
      beginMount: [],
      minDate: minDate,
      maxDate: maxDate,
      from_date: minDate.toISOString().split("T")[0],
      to_date: now.toISOString().split("T")[0],
      product: null,
      product_options: [],
      product_type: null,
      product_type_options: [],
      process_type: null,
      process_type_options: [],
      client_customer: null,
      client_customer_options: []
    };
  },
  watch: {
    client_customer(newVal, oldVal) {
      this.refreshData();
    },
    product(newVal, oldVal) {
      this.refreshData();
    },
    product_type(newVal, oldVal) {
      this.refreshData();
    }
  },
  methods: {
    beginChartMount(bool) {
      this.beginMount.push(true);
    },
    downloadReport() {
      const element = document.getElementById("report");
      const opt = {
        margin: 0.5,
        image: { type: "jpeg", quality: 0.98 },
        filename: "Estadisticas Recepcion_" + this.from_date + "-" + this.to_date + ".pdf",
        html2canvas: { dpi: 192, letterRendering: true },
        jsPDF: { unit: "in", format: "letter", orientation: "p" }
      };
      html2pdf().from(element).set(opt).save();
    },
    refreshData() {
      this.beginMount = [];
      this.ready = false;
      this.$nextTick((_) => {
        this.ready = true;
      });
    },
    getCustomers() {
      this.$axios
        .get("/production/get_customers/")
        .then((res) => {
          const data = res.data.data;
          const customers = [];
          for (let key in data) {
            const customer = data[key];
            customers.push(customer);
          }
          this.client_customer_options = customers;
          this.client_customer_options.unshift({ text: "Todo", value: null });
        })
        .catch((error) => console.log(error));
    },
    getProducts() {
      this.$axios
        .get("/production/get_products/")
        .then((res) => {
          const data = res.data.data;
          const products = [];
          for (let key in data) {
            const product = data[key];
            products.push(product);
          }
          this.product_options = products;
          this.product_options.unshift({ text: "Todo", value: null });
        })
        .catch((error) => console.log(error));
    },
    getProductTypes() {
      this.$axios
        .get("/production/get_product_types/")
        .then((res) => {
          const data = res.data.data;
          const product_types = [];
          for (let key in data) {
            const product_type = data[key];
            product_types.push(product_type);
          }
          this.product_type_options = product_types;
          this.product_type_options.unshift({ text: "Todo", value: null, exportable: null });
        })
        .catch((error) => console.log(error));
    }
  },
  async mounted() {
    this.loading = true;
    this.getCustomers();
    this.getProducts();
    this.getProductTypes();
    this.ready = true;
  }
};
</script>

<style scoped>
.card {
  border-radius: 10px;
}
</style>
